import request from "../base-request";

export declare interface DirectReportData {
	_id: string;
	directReports?: Array<DirectReport>;
}

export type DirectReport = {
	_id: string;
	company: string;
	custom_field_values: any[];
	department: string;
	email: string;
	invited: boolean;
	name: string;
	manager: string;
	last_seen: string;
};

export const getUserDirectReports = async (userID: string, includeDeactivated = false) => {
	try {
		const [directReports] = await request<DirectReportData>(
			`/api/v1.0/direct-reports/${userID}/?include_deactivated=${includeDeactivated}`
		);

		return directReports;
	} catch (error) {
		throw error;
	}
};
